import React, {Fragment} from "react";
import { FormGroup } from "../form/FormGroup";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { UserLabel } from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { Form, FormListener } from "../form/Form";
import { FormSubmitError, FormSubmitSuccess } from "../form/FormFeedback";
import { LoadingViewState, RouterView } from "../RouterView";
import { FormInput } from "../form/FormInput";
import { Submit } from "../form/Submit";
import { UserLabelService } from "../../services/UserLabelService";
import { Validators } from "../form/Validators";
import { formatDate } from "../../util/date";

interface State extends LoadingViewState {
    userLabel?: UserLabel;
    validationMap? : any;
}

interface Props extends RouteComponentProps {

}

export class EditUserLabelView extends RouterView<Props, State> implements FormListener<UserLabel>{
    service: UserLabelService;
    constructor(props : Props){
        super(props);
        this.service = getContainer().getUserLabelService();
        this.state = { userLabel: {enabled:true}, validationMap: {}, loading: true};
    }

    loadContent() : void {
        var id = (this.props.match.params as any).id;
        if(id!=="new"){
            this.getUserLabel(id);
        }  
        if(id==="new"){
   
            this.props.history.push("/user-label/new");
           
        }
    }

   
    
    componentDidUpdate(prevProps: Props, prevState: State): void {
        if(this.props.location.pathname==="/user-label/new"  && this.props.location.pathname!==prevProps.location.pathname){
            this.setState({
                userLabel:{enabled:true}
            })
        }
    }


    getUserLabel(id:any){
        this.service.getUserLabel(id).then((userLabel:UserLabel)=>{
            if(userLabel.timestamp!==undefined){
                userLabel.timestamp = new Date(formatDate(userLabel.timestamp));
            }
            this.setState({ userLabel: userLabel });
        })
    }

    onSubmit(): Promise<any> | undefined {
        if(!this.state.userLabel) return;
        if(this.state.userLabel.value!=="" && this.state.userLabel.description!==""){
            return this.service.save(this.state.userLabel).then((userLabel:UserLabel)=>{ 
                this.props.history.push("/user-label/"+userLabel.id+"");     
                this.getUserLabel(userLabel.id);
            })
        }
    }

    formDidUpdate(formModel: UserLabel, validationMap?: any) {
        this.setState({userLabel : formModel, validationMap : validationMap})
    }

    getTitle() : string {
        return "Edit/Create User Tags";
    }

    renderContent() {
        return (
            <Fragment>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <div className={"row"}>
                            <div className="col-lg-12">
                                <Form className="form form-horizontal" formListener={this} validationMap={this.state.validationMap} modelObject={this.state.userLabel} >
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="UserLabel status was updated successfully" />
                                    <div className={"card-box"}>
                                        <div className="ibox-content">
                                            <table className={"table table-striped"}>
                                                <tbody>
                                                {(this.props.match.params as any).id!=="new" && (
                                                    <tr>
                                                        <td>ID:</td>
                                                        <td>
                                                        <FormGroup className="form-group mb-3">
                                                            <FormInput className="form-control" model="id" type="integer" readOnly={true}/>
                                                        </FormGroup>
                                                        </td>
                                                    </tr>
                                                )}
                                                
                                                <tr>
                                                    <td>Tag</td>
                                                    <td>
                                                    <FormGroup className="form-group mb-3">
                                                        <FormInput  className="form-control" model="value" type="text" validators={[Validators.required()]}/>
                                                    </FormGroup>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Description</td>
                                                    <td>
                                                    <FormGroup className="form-group mb-3">
                                                        <FormInput  className="form-control" model="description" type="text" validators={[Validators.required()]}/>
                                                    </FormGroup>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Enabled</td>
                                                    <td>
                                                        <FormGroup className="form-group mb-3">
                                                            <FormInput model="enabled" type="checkbox" />
                                                        </FormGroup>
                                                    </td>
                                                </tr>
                                                {(this.props.match.params as any).id!=="new" && (
                                                    <tr>
                                                        <td>Created By</td>
                                                        <td>
                                                        <FormGroup className="form-group mb-3">
                                                            <FormInput className="form-control" model="createdBy" type="integer" readOnly={true}/>
                                                        </FormGroup>
                                                        </td>
                                                    </tr>
                                                )}
                                                
                                                {(this.props.match.params as any).id!=="new" && (
                                                    <tr>
                                                        <td>Timestamp</td>
                                                        <td>
                                                        <FormGroup className="form-group mb-3">
                                                            <FormInput className="form-control" model="timestamp" type="datetime" readOnly={true}/>
                                                        </FormGroup>
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                            <div className={"card"}>
                                                <div className={"card-body"}>
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="ibox float-e-margins">
                                                                <div className="ibox-content">
                                                                    <div className="ibox-title">
                                                                        <h5>Actions</h5>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <div className="col-sm-10 col-sm-offset-2">
                                                                            <Submit className="btn btn-primary waves-effect waves-light">Save</Submit>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }  
}

export default withRouter(EditUserLabelView);